import EmptyLayout from '../layout/EmptyLayout';
import FullLayout from '../layout/fullLayout';
import type {AppRouteConfig} from './route.types';
import AuthLayout from '../layout/authLayout';
import Confirmation from '../pages/auth/confirmation';
import StepInfo from '../pages/StepInfo';
import SignUp from '../pages/auth/signUp';
import Login from '../pages/login';
import RuleWrapper from '../pages/auth/rule';

export const authRoutes: AppRouteConfig[] = [
  {
    path: 'steps',
    element: EmptyLayout,
    children: [{index: true, element: StepInfo}],
  },
  {
    path: 'auth',
    element: AuthLayout,
    children: [
      {path: 'signUp', element: SignUp},
      {path: 'login', element: Login},
      {path: 'confirmation', element: Confirmation},
    ],
  },
  {
    path: 'auth/rule',
    element: FullLayout,
    children: [{index: true, element: RuleWrapper}],
  },
];